import React, { memo, useCallback } from "react";

import { Text, VStack, Button } from "@chakra-ui/react";
import colors from "app/colors";
import SyncoLogoIcon from "modules/icons/synco-logo-icon";
import { AUTH_PATH } from "modules/utils/Constants";
import { useRouter } from "next/router";
import { SyncoInviteSuccessIcon } from "modules/icons";

const InviteSuccess = () => {
  const { push } = useRouter();

  const onLoginClicked = useCallback(() => {
    push({
      pathname: AUTH_PATH,
    });
  }, [push]);

  return (
    <VStack
      mt="85px"
      bg={colors.white}
      borderRadius={32}
      w={444}
      py={8}
      px={8}
      spacing={4}
    >
      <SyncoLogoIcon boxSize={110} />
      <SyncoInviteSuccessIcon boxSize={208} />
      <VStack spacing={0} w="full">
        <Text fontFamily="Outfit" fontWeight={700} fontSize={24}>
          You’re all Set!
        </Text>
        <Text
          fontWeight={500}
          fontSize={18}
          color={colors.grayMain}
          textAlign="center"
        >
          Now login to Synco app to chat with your team.
        </Text>
      </VStack>
      <Button
        h="40px"
        w="364px"
        alignSelf="center"
        onClick={onLoginClicked}
        fontWeight={500}
        fontSize={16}
      >
        Login
      </Button>
    </VStack>
  );
};

export default memo(InviteSuccess);
